<template>
  <div>
    <b-modal
      id="delete-confirmation"
      size="lg"
      centered
      title="Delete Confirmation"
      ok-only
      no-stacking
      no-close-on-backdrop
      @close="closeModal"
    >
      <h6 class="my-2">Are you sure you want to delete this project?</h6>
      <b-table
        class="project-table"
        :items="[projectToDelete]"
        :fields="fields"
      >
        ></b-table
      >
      <template #modal-footer>
        <b-button variant="primary" @click="closeModal">Cancel</b-button>
        <b-button variant="primary" @click="deleteConfirmed">Delete</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'DeleteConfirmationModal',
  props: {
    modalShow: Boolean,
    projectToDelete: Object,
  },
  data() {
    return {
      fields: [
        {
          key: 'projectName',
          lable: 'Project Name',
        },
        {
          key: 'lastModifiedTime',
          lable: 'Last Modified',
        },
        {
          key: 'createdTime',
          label: 'Created',
        },
      ],
    };
  },
  mounted() {
    if (this.modalShow) {
      this.showModal();
    }
  },
  methods: {
    showModal() {
      this.$bvModal.show('delete-confirmation');
    },
    closeModal() {
      this.$emit('toggle', 'deleteConfirmationModal');
    },
    deleteConfirmed() {
      this.$emit('delete');
    },
  },
};
</script>

<style></style>
